import { Button } from "@shared/ui";
import { FileText, ScrollText, UserPlus } from "lucide-react";
import type { ReactNode } from "react";
import styles from "./ExecutionBulkFooter.module.scss";

interface ExecutionBulkFooterProps {
  selectedCount: number;
  onClear: () => void;
  onAssign: () => void;
  onAttachBrief: () => void;
  onAttachScript: () => void;
  extraActions?: ReactNode;
}

export function ExecutionBulkFooter({
  selectedCount,
  onClear,
  onAssign,
  onAttachBrief,
  onAttachScript,
  extraActions,
}: ExecutionBulkFooterProps) {
  return (
    <div className={styles.bar}>
      <div className={styles.countBlock}>
        <span className={styles.count}>{selectedCount} selected</span>
        <button type="button" className={styles.clear} onClick={onClear}>
          Clear selection
        </button>
      </div>
      <div className={styles.actions}>
        {extraActions}
        <Button onClick={onAssign} className={styles.assignButton}>
          <UserPlus size={14} />
          Assign Ops POC
        </Button>
        <Button onClick={onAttachScript} className={styles.assignButton}>
          <ScrollText size={14} />
          Attach script
        </Button>
        <Button
          type="primary"
          onClick={onAttachBrief}
          className={styles.attachButton}
        >
          <FileText size={14} />
          Attach brief
        </Button>
      </div>
    </div>
  );
}
